import { memo, PropsWithChildren } from 'react';
import cn from 'classnames';
import { createUseStyles } from 'react-jss';

import Drawer from 'app/components/common/drawer/Drawer';
import { useAppContext } from 'app/lib/AppContext';

const Layout = (props: PropsWithChildren) => {
  const { children } = props;
  const { mode } = useAppContext();
  const classes = useStyles();

  return (
    <div className={cn(classes.container, { [classes.preview]: mode === 'preview' })}>
      <Drawer />
      <div className={classes.body}>{children}</div>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    position: 'relative',
    display: 'block',
    flex: 1,
    background: '#f9f7f4',
    overflow: 'hidden',
  },
  preview: {
    background: 'transparent',
  },
  body: {
    width: '32em',
    margin: '0 auto',
  },
});

export default memo(Layout);
